<script setup lang="ts">
import { nextTick, onMounted, ref, useAttrs, watch } from 'vue';

const props = defineProps<{
  modelValue: string;
  maxHeight?: number | string;
}>();
const emit = defineEmits(['update:modelValue']);

const textareaRef = ref<HTMLTextAreaElement | null>(null);
const attrs = useAttrs();

function adjustHeight() {
  const el = textareaRef.value;
  if (!el) return;
  el.style.height = 'auto';
  const maxHeight = Number(props.maxHeight) || 400;
  el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
  el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
}

onMounted(() => {
  nextTick(adjustHeight);
});
watch(
  () => props.modelValue,
  () => nextTick(adjustHeight),
);

function onInput(e: Event) {
  emit('update:modelValue', (e.target as HTMLTextAreaElement).value);
  adjustHeight();
}
</script>

<template>
  <textarea
    class="c-textArea"
    ref="textareaRef"
    v-bind="attrs"
    :value="modelValue"
    @input="onInput"
  />
</template>
